import { OrganizationAccessService as OvermapOrganizationAccessService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class OrganizationAccessService extends OvermapOrganizationAccessService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
